import type {EditorStarterItem} from '../item-type';
import {computeGroupGeometry} from './group-geometry';

/** Explicitly reset a cut compound's padding/pivot, without moving its contents. */
export function fitGroupFrame(items:Record<string,EditorStarterItem>,id:string):Record<string,EditorStarterItem>{
  const group=items[id];
  if(group?.type!=='group'||!group.preserveGroupFrame||!group.children.length)return items;
  const geometry=computeGroupGeometry(group.children,items);
  if(geometry.width<=0||geometry.height<=0||geometry.durationInFrames<=0)return items;
  const {preserveGroupFrame: _frame,...rest}=group;
  return {...items,[id]:{...rest,...geometry,
    animations:group.animations?.map(({timelineWindow: _window,...animation})=>animation),
    positionKeyframes:group.positionKeyframes?.map(point=>({...point,frame:point.frame+group.from-geometry.from})),
  }};
}
